import React, { useEffect, useState } from "react";
import { browserHistory, Link } from "react-router";
import PropTypes from "prop-types";
import _ from "lodash";
import util from "../util/util";
import Pagination from "../pagination/pagination";
import InviteListTable from "./invite-list-table";

const jQuery = window.jQuery;

export default function InviteList(props) {
  // page of invites results;
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(0);
  // invites to display (will be populated by an Ajax call);
  const [invites, setInvites] = useState([]);

  useEffect(() => {
    const page = Number(_.get(props, `params.page`, 1));

    // get the invites for this station;
    const getInvites = () => {
      util
        .getStationInvites({
          page: page
        })
        .then(data => {
          setTimeout(() => {
            // setting the data returned from the backend
            setPageCount(Math.ceil(data.count / util.inviteResultsPerPage));
            setInvites(data.results.length ? data.results : false);

            // setting the state of the new data, for the UI
            setPage(page);
          }, util.delayList);
        });
    };

    getInvites();
  }, [props]);

  // delete the invite associated with this station;
  const deleteInvite = invite => {
    // using this for the 'Delete Modal'
    const title = `Delete Invite from this Station`;
    const body = `<p>Are you sure you want to delete the invitation for <strong>${
      invite.group ? invite.group.name : ``
    }: ${invite.email}</strong>?</p>`;
    const buttonTextDefault = `Delete the Invite`;
    const buttonTextLoading = `Deleting the Invite`;
    const iconClass = `fa-trash-o`;
    const $modal = util.renderModal(
      title,
      body,
      buttonTextDefault,
      buttonTextLoading,
      iconClass
    );
    const $confirmButton = $modal.find(`.btn-danger`);

    // remove the invite on confirmation of the modal;
    $confirmButton.one(`click`, () => {
      $confirmButton.button(`loading`);

      util
        .deleteInviteFromStation(invite.id)
        .fail(() => {
          setTimeout(() => {
            // reset the button on fail so it can be clicked again;
            $confirmButton.button(`reset`);
          }, util.delayForm);
        })
        .then(() => {
          // hiding the Modal
          $modal.modal(`hide`);
          // going to the first page of the Invites,
          // and get the updated Invites list from the backend
          browserHistory.push(`/invites/1/`);
        });
    });

    // attach the modal to the DOM, and then show it;
    jQuery(`body`).append($modal);
    $modal.modal(`show`);
  };

  return (
    <div>
      <div className="row">
        <div className="col-xs-6">
          <h4 className="page__title">Invites</h4>
        </div>
        <div className="col-xs-6">
          <p className="page__actions">
            <Link to={util.returnInviteFormUrl()} className="btn btn-primary">
              <i className="fa fa-plus" aria-hidden="true"></i>
              Invite Users
            </Link>
          </p>
        </div>
      </div>

      <hr />

      <InviteListTable
        currentPage={page}
        onClickDeleteInvite={invite => deleteInvite(invite)}
        invites={invites}
      />

      <Pagination currentPage={page} pageCount={pageCount} path="invites" />
    </div>
  );
}

InviteList.propTypes = {
  params: PropTypes.object
};
